import { useState, useEffect, useRef, useContext } from 'react';
import { validateForm } from '../utils/validateForm';
import BookerContext from '../context/bookerContext';
import store from '../store/bookerStore';

export const useValidatedInput = (btnClass, isInitValid = false) => {
  const [isValid, setIsValid] = useState(!!isInitValid);
  const [doValidateForm, setDoValidateForm] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isDisabled, setIsDisabled] = useState(!isInitValid);
  const [dispatchClick, doDispatchClick] = useState(false);
  const btn = useRef([]);

  const context = useContext(BookerContext);
  const {
    state,
    state: { isWebBooker },
  } = context;

  const toggleBtnDisability = makeDisable => {
    btn.current[0] = document.getElementsByClassName(btnClass)[0];
    if (!btn.current[0]) return;

    const hasClassDisabled = btn.current[0].classList.value.includes('disabled');
    makeDisable
      ? !hasClassDisabled && btn.current[0].classList.add('disabled')
      : hasClassDisabled && btn.current[0].classList.remove('disabled');
  };

  useEffect(() => {
    if (!btnClass) return;

    btn.current[0] = document.getElementsByClassName(btnClass)[0];
  }, [btnClass]);

  useEffect(() => {
    if (!btn.current[0]) return;

    const hasClassDisabled = btn.current[0].classList.value.includes('disabled');
    isDisabled
      ? !hasClassDisabled && btn.current[0].classList.add('disabled')
      : hasClassDisabled && btn.current[0].classList.remove('disabled');
  }, [isDisabled]);

  useEffect(() => {
    if (!doValidateForm) return;

    const isFValid = validateForm({ state, store, isWebBooker });
    setIsFormValid(isFValid);
  }, [isValid, doValidateForm, state, isWebBooker]);

  useEffect(() => {
    if (isValid && ((doValidateForm && isFormValid) || !doValidateForm)) {
      setIsDisabled(false);
      setDoValidateForm(true);
      return;
    }
    setIsDisabled(true);
  }, [isValid, doValidateForm, isFormValid, isDisabled]);

  useEffect(() => {
    if (!(dispatchClick && btn.current[0] && isValid && !isDisabled)) return;

    const event = new Event('click', { bubbles: true });
    btn.current[0].dispatchEvent(event);
    doDispatchClick(false);
  }, [dispatchClick, isValid, isDisabled, btn]);

  return [setIsValid, setDoValidateForm, isFormValid, toggleBtnDisability];
};
